import { useEffect, useState } from 'react'

export interface Countdown {
  days: number
  hours: number
  minutes: number
  seconds: number
  isLive: boolean
}

function getCountdown(targetMs: number): Countdown {
  const diff = Math.max(0, targetMs - Date.now())
  return {
    days: Math.floor(diff / 86_400_000),
    hours: Math.floor((diff / 3_600_000) % 24),
    minutes: Math.floor((diff / 60_000) % 60),
    seconds: Math.floor((diff / 1000) % 60),
    isLive: diff === 0,
  }
}

export function useCountdown(targetIso: string): Countdown {
  const targetMs = new Date(targetIso).getTime()
  const [countdown, setCountdown] = useState(() => getCountdown(targetMs))

  useEffect(() => {
    if (countdown.isLive) return
    const id = window.setInterval(() => {
      setCountdown(getCountdown(targetMs))
    }, 1000)
    return () => window.clearInterval(id)
  }, [targetMs, countdown.isLive])

  return countdown
}
